module.exports = __webpack_public_path__ + "static/media/movies.29cc4c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/movies.jpg
// module id = 5939
// module chunks = 0